export const signs: Record<string, string> = {
	sign_default: "The sign is blank.",
	sign_playground_demo: "Welcome to the playground level.",
	sign_wasteland_outpost: "Entrance to caves",
	sign_bullet_storage: "Bullet storage",
};
